/**
 * iter87.468 — Intro/explainer video ("Start a Rivalry" voiceover walkthrough).
 *
 * Self-hosted at /videos/start-a-rivalry.mp4 (served from our own domain,
 * not the external upload link) + a poster frame grabbed ~1s in so the
 * section never shows a blank black box before the reader taps play.
 * Has a voiceover, so autoplay stays OFF and unmuted by design — the
 * reader opts in with a real tap.
 */
import React from "react";
import { Play } from "lucide-react";

export const INTRO_VIDEO_SRC = "/videos/start-a-rivalry.mp4";
export const INTRO_VIDEO_POSTER = "/videos/start-a-rivalry-poster.jpg";

export default function IntroVideo({ className = "", testId = "intro-video" }) {
    const videoRef = React.useRef(null);
    const [playing, setPlaying] = React.useState(false);

    return (
        <div
            data-testid={testId}
            className={`relative w-full aspect-video rounded-2xl overflow-hidden border border-cyber/30 bg-black shadow-brutalYellow ${className}`}
        >
            <video
                ref={videoRef}
                className="w-full h-full object-cover"
                controls
                playsInline
                preload="metadata"
                poster={INTRO_VIDEO_POSTER}
                onPlay={() => setPlaying(true)}
                onPause={() => setPlaying(false)}
                data-testid={`${testId}-element`}
            >
                <source src={INTRO_VIDEO_SRC} type="video/mp4" />
                Your browser doesn't support embedded video — you can still{" "}
                <a href={INTRO_VIDEO_SRC} className="text-cyber underline">
                    download the clip
                </a>
                .
            </video>

            {/* Custom big play affordance over the poster — the native
                control bar alone reads too small/subtle on a yellow-on-
                black poster frame. Hides itself the moment playback starts
                and never re-shows (native controls take over from there). */}
            {!playing && (
                <button
                    type="button"
                    onClick={() => videoRef.current?.play()}
                    aria-label="Play intro video"
                    data-testid={`${testId}-play-overlay`}
                    className="absolute inset-0 flex items-center justify-center bg-black/10 hover:bg-black/25 transition-colors group"
                >
                    <span className="w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-cyber flex items-center justify-center border-2 border-black shadow-brutalYellow group-hover:scale-105 transition-transform">
                        <Play className="w-7 h-7 sm:w-8 sm:h-8 text-black ml-1" fill="currentColor" />
                    </span>
                </button>
            )}
        </div>
    );
}
